const ADDRESS_COMPONENT_ENTRIES = Object.entries({
  home: ['street_number'],
  postal_code: ['postal_code'],
  street: ['street_address', 'route'],
  region: [
    'administrative_area_level_1',
    'administrative_area_level_2',
    'administrative_area_level_3',
    'administrative_area_level_4',
    'administrative_area_level_5',
  ],
  city: [
    'locality',
    'sublocality',
    'sublocality_level_1',
    'sublocality_level_2',
    'sublocality_level_3',
    'sublocality_level_4',
    'postal_town',
  ],
  country: ['country'],
});

/**
 * Get address based on location.
 *
 * @param {GeocoderService} geocoder, Instance of the cervice.
 * @param {coordinate} coordinate, LatLng object.
 *
 * @return {Promise<string>}, address.
 */
export default (geocoder, coordinate) => new Promise((resolve) => {
  try {
    geocoder.geocode({
      location: coordinate,
    }, (results, status) => {
      if (status !== 'OK') {
        resolve('');
        return;
      }

      if (!results.length) {
        resolve('');
        return;
      }

      const address = results[0].address_components.reduce(
          (target, component) => {
            ADDRESS_COMPONENT_ENTRIES.forEach(([key, value]) => {
              if (value.includes(component.types[0]) && target[key] === '') {
                // eslint-disable-next-line no-param-reassign
                target[key] = component.long_name;
              }
            });

            return target;
          },
          {
            home: '',
            postal_code: '',
            postal_town: '',
            street: '',
            region: '',
            city: '',
            country: '',
          },
      );

      resolve(address.city || address.region || address.country);
    });
  } catch (e) {
    resolve('');
  }
});
